import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export const RegistrationStep = styled.div<IThemeProps>`
  position: relative;

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    padding: 15px 0;
  }
`;

export const Title = styled.h1<IThemeProps>`
  height: 40px;
  line-height: 40px;
  font-size: ${(props: IThemeProps) => props.theme.typography.h500};
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  text-transform: uppercase;
  color: ${(props: IThemeProps) => props.theme.colors.black};
  margin-bottom: ${(props: IThemeProps) => props.theme.spacing.desktop.s300}px;

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    margin-bottom: 0;
  }
`;
